import React from 'react';
import { SpeedDialContextType } from './SpeedDialContextType';

export default React.createContext<Partial<SpeedDialContextType>>({});
